import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setMode } from "../../redux/reducers/basket";
import {
	getApplication,
	getRestaurant,
	getServiceTypes,
} from "../../utils/commons";

const SelectMode = (props) => {
	const basket = useSelector((state) => state.basket);
	const restaurant = useSelector((state) => state.restaurant.restaurant);

	const dispatch = useDispatch();
	const serviceTypes = getServiceTypes();
	const [selectedMode, setSelectedMode] = useState(basket.mode || "takeAway");

	useEffect(() => {}, []);

	const onSelectMode = (mode) => {
		dispatch(
			setMode({
				mode,
				deliveryFees: mode === "delivery" ? restaurant.deliveryFees : 0,
			})
		);
	};

	return (
		<>
			<Modal.Header className="select-mode-modal-header">
				<h4 className="text-center">
					Choisissez votre mode de consommation :{" "}
				</h4>
			</Modal.Header>
			<Modal.Body>
				<div className="col-sm-12 col-12 justify-content-around">
					<div className="row services-button-container">
						{serviceTypes.includes("takeAway") && (
							<div className="form-group">
								<button
									type="button"
									className={
										"btn-custom btn-service shadow-none " +
										(selectedMode != "takeAway" ? "light" : "")
									}
									onClick={() => {
										setSelectedMode("takeAway");
									}}
								>
									A emporter
								</button>
							</div>
						)}
						{serviceTypes.includes("onSite") && (
							<div className="form-group">
								<button
									type="button"
									className={
										"btn-custom btn-service shadow-none  " +
										(selectedMode != "onSite" ? "light" : "")
									}
									onClick={() => {
										setSelectedMode("onSite");
									}}
								>
									Sur place
								</button>
							</div>
						)}
						{serviceTypes.includes("delivery") && (
							<div className="form-group">
								<button
									type="button"
									disabled={!restaurant || !restaurant.deliveryEnabled}
									className={
										"btn-custom btn-service shadow-none  " +
										(selectedMode != "delivery" ? "light" : "")
									}
									onClick={() => setSelectedMode("delivery")}
								>
									En Livraison
								</button>
								{(!restaurant || !restaurant.deliveryEnabled) && (
									<div className="">
										<span className="fs-14" style={{ paddingLeft: 20 }}>
											Non disponible
										</span>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
				<div className="text-center">
					<button
						type="button"
						className="btn-custom"
						disabled={false}
						onClick={() => {
							onSelectMode(selectedMode);
							props.onHide();
						}}
						style={{}}
					>
						Valider
					</button>
				</div>
			</Modal.Body>
		</>
	);
};

export default SelectMode;
